import ScrollReveal from '@/components/ui/ScrollReveal'
import type { ProcessImage } from '@/types'

interface ProjectProcessProps {
  images: ProcessImage[]
  sectionNumber?: string
}

export default function ProjectProcess({ images, sectionNumber }: ProjectProcessProps) {
  return (
    <ScrollReveal>
      <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-8 md:gap-12">
        <div>
          {sectionNumber && (
            <span className="text-label text-accent block mb-1">{sectionNumber}</span>
          )}
          <span className="text-label uppercase tracking-widest text-text-muted">Process</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {images.map((image) => (
            <div key={image.src} className="flex flex-col gap-2">
              <div className="aspect-video rounded-card overflow-hidden bg-surface">
                <img
                  src={image.src}
                  alt={image.caption}
                  width={1280}
                  height={720}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-caption text-text-muted">{image.caption}</span>
            </div>
          ))}
        </div>
      </div>
    </ScrollReveal>
  )
}
